import { styled } from '@classify/react-core-components/styles';
import Stack from '@classify/react-core-components/Stack';

const HeaderDropDownGroup = styled(Stack)({
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 4,
});

export default HeaderDropDownGroup;
